import { ComponentPropsWithoutRef } from 'react';
import useAuthenticatedImageSrc from 'src/hooks/useAuthenticatedImageSrc';

type ImageWithAuthenticationProps = ComponentPropsWithoutRef<'img'> & { authenticationNeeded?: boolean };

const ImageWithAuthentication = ({
  src,
  alt,
  authenticationNeeded = false,
  ...props
}: ImageWithAuthenticationProps) => {
  const effectiveSrc = useAuthenticatedImageSrc(src, authenticationNeeded);
  return <img src={effectiveSrc} alt={alt} {...props} />;
};

export default ImageWithAuthentication;
